import React from 'react';
import { Spinner } from 'react-bootstrap'
import './Loader.css';

export default function Loader(props) {
    const style = { position: "fixed", top: "50%", left: "50%" };
    return (
        <div className="DarkBackground">
            <Spinner animation="border" variant="success" style={style} />
            <span className="sr-only">Loading...</span>
            {/* {props.showText? <span >Please wait while</span> : null} */}
        </div>
    )
}